export default __webpack_public_path__ + "static/19old-6ced6de86151bf6e92d8ff0cc16dd22f.png";